import { render, staticRenderFns } from "./wechat-manage.vue?vue&type=template&id=08ddf3e2&scoped=true"
import script from "./wechat-manage.vue?vue&type=script&lang=js"
export * from "./wechat-manage.vue?vue&type=script&lang=js"
import style0 from "./wechat-manage.vue?vue&type=style&index=0&id=08ddf3e2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ddf3e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ddf3e2')) {
      api.createRecord('08ddf3e2', component.options)
    } else {
      api.reload('08ddf3e2', component.options)
    }
    module.hot.accept("./wechat-manage.vue?vue&type=template&id=08ddf3e2&scoped=true", function () {
      api.rerender('08ddf3e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechats/components/wechat-manage.vue"
export default component.exports